import { createSelector } from 'reselect';


export function getProvincesLists(state) {
  return state.provinces;
}

export function getProvincesListsById(state, currentProvincesListId) {
  return getProvincesLists(state).get(currentProvincesListId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentProvincesLists = createSelector(
  getProvincesLists,
  provinceslist => provinceslist.get(provinceslist.get('currentProvincesListId'))
);
